import { Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarHandler } from 'src/app/other/open-snack-bar';
import { MatAccordion } from '@angular/material/expansion';
import { StaticMemory } from 'src/app/handler/static_memory';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocationSetDialogService } from './location-set-dialog.service';
import { PinCodeValidator as PinCodeValidator } from 'src/app/pages/checkout/pin-code-validator';
import { AUTHGWCONSTANTS } from 'src/app/authorization/authconstatnts';
import { AppService } from 'src/app/app.service';
import { BuildConfig } from 'src/app/handler/build-config';
import { GoogleMapLoaderService } from 'src/app/handler/google-map-loader';
@Component({
  selector: 'app-location-set-dialog',
  templateUrl: './location-set-dialog.component.html',
  styleUrls: ['./location-set-dialog.component.scss'],
  providers: [LocationSetDialogService]
})
export class LocationSetDialogComponent implements OnInit {

  isServiceArea = StaticMemory.isServiceArea;
  title: string = 'Set Your Location';
  data: any = {};
  addressArray: Array<any> = [];
  addressUpdate: boolean = false;
  panelExpand: number = 0;
  loadContainer: boolean = false;
  googleMap: any;
  marker: any = null;
  geocoderService: any;
  previousSelectedLocation: google.maps.LatLng | null = null;
  locationMessage: string = '';
  dialogType: number = 0;
  updateLocation: boolean = false;

  addressTypeArray: Array<any> = [
    { name: 'Home', value: 'Home' },
    { name: 'Office', value: 'Office' },
    { name: 'Other', value: 'Other' },
  ];

  @ViewChild('myaccordion') accordion: MatAccordion;

  constructor(
    public dialogRef: MatDialogRef<LocationSetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private service: LocationSetDialogService,
    private snackbar: SnackBarHandler,
    private router: Router
  ) {
    this.dialogData = JSON.stringify(this.dialogData);
    this.dialogData = JSON.parse(this.dialogData);
    if (this.dialogData) {
      this.locationMessage = this.dialogData.location_message;
      if (this.locationMessage && this.locationMessage.length) {
        this.loadContainer = true;
      } else {
        this.loadContainer = false;
      }
      this.dialogType = this.dialogData.type;
    }
    this.data = {};
    this.data.id = '';
    this.data.fullName_text = '';
    this.data.pinCode_text = null;
    this.data.cityDistrictTown_text = '';
    this.data.houseNo_text = '';
    this.data.locality_text = '';
    this.data.phoneNumber_text = null;
    this.data.landmark_text = '';
    this.data.selectAddress = '';
    this.data.selectAddressType = 'Home';
    this.data.selectDefault = true;
    this.data.latitude_text = null;
    this.data.longitude_text = null;
  }

  ngOnInit(): void {
    this.getAddress();
    const context = this;
    navigator.permissions.query({ name: "geolocation" }).then((permission) => {
      context.updateLocation = true;
      if (permission.state === 'denied') {
        context.updateLocation = true;
        context.data.latitude_text = null;
        context.data.longitude_text = null;
        document.getElementById('field-text-display').click();
      } else if (permission.state === 'granted') {
        context.updateLocation = false;
        context.initMap();
        document.getElementById('field-text-display').click();
      }
      permission.onchange = () => {
        if (permission.state === 'denied') {
          context.updateLocation = true;
          context.data.latitude_text = null;
          context.data.longitude_text = null;
          document.getElementById('field-text-display').click();
        } else if (permission.state === 'granted') {
          context.updateLocation = false;
          context.initMap();
          document.getElementById('field-text-display').click();
        }
      };
    });
  }

  onClose(): void {
    if (this.addressUpdate && window.location.href.includes('/checkout')) {
      window.location.reload();
      return
    }
    LocationSetDialogService.dialogResult = false;
    this.dialogRef.close();
  }

  onUpdateAddress(): void {
    this.loadContainer = false;
    if (this.addressArray && this.addressArray.length) {
      this.panelExpand = null;
    } else {
      this.data.selectDefault = true;
      this.panelExpand = 1;
    }
  }

  getAddress(): void {
    this.addressArray = [];
    this.service.getAddress().subscribe((success) => {
      if (success.status && success.result && success.result.length) {
        this.addressArray = success.result;
        if (this.addressArray && this.addressArray.length) {
          if (this.addressArray.length === 1) {
            this.data.selectAddress = this.addressArray[0]._id;
            this.data.selectDefault = this.addressArray[0].default;
            localStorage.setItem(AUTHGWCONSTANTS.addressObject, JSON.stringify(this.addressArray[0]));
            StaticMemory.addressObject = this.addressArray[0];
            AppService.addressChange.next(this.addressArray[0]);
          }
          if (this.addressArray.length > 1) {
            for (let i = 0; i < this.addressArray.length; i++) {
              if (this.addressArray[i].default) {
                this.data.selectAddress = this.addressArray[i]._id;
                this.data.selectDefault = this.addressArray[i].default;
                localStorage.setItem(AUTHGWCONSTANTS.addressObject, JSON.stringify(this.addressArray[i]));
                StaticMemory.addressObject = this.addressArray[i];
                AppService.addressChange.next(this.addressArray[i]);
              }
            }
          }
          this.onClosePanel();
        } else {
          this.loadContainer = true;
          this.onCreate();
          this.initMap();
          AppService.addressChange.next(null);
          localStorage.removeItem(AUTHGWCONSTANTS.addressObject);
          localStorage.removeItem(AUTHGWCONSTANTS.serAreaObject);
        }
      } else {
        this.onCreate();
        this.initMap();
        this.loadContainer = true;
        AppService.addressChange.next(null);
        localStorage.removeItem(AUTHGWCONSTANTS.addressObject);
        localStorage.removeItem(AUTHGWCONSTANTS.serAreaObject);
      }
    },
      (error) => { },
    );
  }

  initMap(): void {
    const context = this;
    context.marker = null;
    const coordinates = [
      { lat: 23.918747, lng: 91.391956 }, // NE
      { lat: 23.920944, lng: 91.219265 }, // NW
      { lat: 23.775872, lng: 91.221668 }, // SW
      { lat: 23.796292, lng: 91.400196 }, // SE
    ];
    const maxLat = Math.max(...coordinates.map(coord => coord.lat));
    const minLat = Math.min(...coordinates.map(coord => coord.lat));
    const maxLng = Math.max(...coordinates.map(coord => coord.lng));
    const minLng = Math.min(...coordinates.map(coord => coord.lng));

    const agartalaBounds = { north: maxLat, south: minLat, east: maxLng, west: minLng };
    const indiaBounds = { north: 37.6, south: 6.7, east: 97.4, west: 68.2 };
    const selectedBounds = indiaBounds
    GoogleMapLoaderService.load().then(() => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          if (position) {
            let latLng: any = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            if (this.panelExpand === 2) {
              latLng.lat = context.data.latitude_text;
              latLng.lng = context.data.longitude_text;
            }
            context.data.latitude_text = latLng.lat;
            context.data.longitude_text = latLng.lng;
            context.googleMap = new google.maps.Map(document.getElementById('map'), {
              restriction: {
                latLngBounds: selectedBounds,
                strictBounds: false,
              },
              center: latLng,
              zoom: 12,
            });
            context.googleMap.addListener('tilesloaded', () => {
              context.onMapLoaded(latLng);
            });
          }
        },
          (error: any) => {
            this.updateLocation = true;
          },
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    });
  }

  onMapLoaded(latLng: any): void {
    const context = this;
    context.googleMap.addListener('click', (event) => {
      const latLng = JSON.parse(JSON.stringify(event.latLng));
      context.data.latitude_text = latLng.lat;
      context.data.longitude_text = latLng.lng;
      context.placeMarker(latLng);
      context.parseAddress(latLng);
    });
    if (!context.marker) {
      context.placeMarker(latLng);
      context.parseAddress(latLng);
    }
  }

  placeMarker(latLng: any): void {
    const context = this;
    if (!context.marker) {
      context.marker = new google.maps.Marker({
        position: latLng,
        map: context.googleMap,
        draggable: true,
      });
      context.parseAddress(latLng);
    }
    context.marker.addListener('dragend', (event) => {
      const newlatLng = JSON.parse(JSON.stringify(event.latLng));
      context.data.latitude_text = newlatLng.lat;
      context.data.longitude_text = newlatLng.lng;
      context.parseAddress(newlatLng);
    });
    context.googleMap.panTo(latLng);
    context.googleMap.setZoom(15);
    context.marker.setPosition(latLng);
  }

  parseAddress(latLng: any): void {
    const context = this;
    if (google.maps && google.maps.Geocoder) {
      const geocoder = new google.maps.Geocoder();
      const latLngObj = new google.maps.LatLng(latLng.lat, latLng.lng);
      geocoder.geocode({ location: latLngObj }, function (results, status) {
        if (status === 'OK' && results.length) {
          const addressComponents = results[0].address_components;
          let pinCode = null;
          let city = null;
          let locality = null;
          let landmark = null;
          for (const component of addressComponents) {
            const types = component.types;
            if (types.includes('postal_code')) {
              pinCode = component.long_name;
            } else if (types.includes('locality')) {
              city = component.long_name;
            } else if (types.includes('sublocality') || types.includes('neighborhood')) {
              locality = component.long_name;
            } else if (types.includes('')) {
              landmark = component.long_name;
            }
          }
          const formattedAddress = results[0].formatted_address;
          landmark = context.extractDesiredAddress(formattedAddress);
          context.data.pinCode_text = Number(pinCode);
          context.data.cityDistrictTown_text = city;
          context.data.locality_text = locality;
          context.data.landmark_text = landmark;
        }
        document.getElementById('field-text-display').click();
      });
    } else {
      console.error('Google Maps API or GeocoderService not available.');
    }
  }

  extractDesiredAddress(fullAddress: string): string {
    const commaIndex = fullAddress.indexOf(',');
    if (commaIndex !== -1) {
      const addressPart = fullAddress.substring(commaIndex + 1).trim();
      const codeIndex = addressPart.indexOf(' ');
      if (codeIndex !== -1) {
        return addressPart.substring(codeIndex + 1).trim();
      } else {
        return addressPart;
      }
    } else {
      return fullAddress;
    }
  }

  onCreate(): void {
    this.panelExpand = 1;
    this.data.fullName_text = '';
    this.data.pinCode_text = null;
    this.data.cityDistrictTown_text = '';
    this.data.houseNo_text = '';
    this.data.locality_text = '';
    this.data.phoneNumber_text = null
    if (StaticMemory.profileDetails && StaticMemory.profileDetails.contact && StaticMemory.profileDetails.contact.length) {
      this.data.phoneNumber_text = StaticMemory.profileDetails.contact[0].value;
    }
    this.data.landmark_text = '';
    this.data.selectAddressType = 'Home';
    this.data.selectDefault = false;
    this.data.latitude_text = null;
    this.data.longitude_text = null;
    this.initMap();
  }

  onEdit(value: any): void {
    this.panelExpand = 2;
    this.data.id = value._id;
    this.data.fullName_text = value.fullName;
    this.data.pinCode_text = value.pinCode;
    this.data.cityDistrictTown_text = value.city;
    this.data.houseNo_text = value.houseNo;
    this.data.locality_text = value.locality;
    this.data.phoneNumber_text = value.phoneNumber;
    this.data.landmark_text = value.landmark;
    this.data.selectAddress = value._id;
    this.data.selectAddressType = value.addressType;
    this.data.selectDefault = value.default;
    this.data.latitude_text = value.location['co-ordinates'][1];
    this.data.longitude_text = value.location['co-ordinates'][0];
    this.initMap();
  }

  onClosePanel(): void {
    this.panelExpand = null;
    this.data.fullName_text = '';
    this.data.pinCode_text = null;
    this.data.cityDistrictTown_text = '';
    this.data.houseNo_text = '';
    this.data.locality_text = '';
    this.data.phoneNumber_text = null;
    this.data.landmark_text = '';
    this.data.selectAddressType = '';
    this.data.selectDefault = false;
    this.data.latitude_text = null;
    this.data.longitude_text = null;
  }

  onChangeAddress(idx: any): void {
    this.data.selectAddress = idx._id;
    const body: any = {
      id: idx._id,
      fullName: idx.fullName,
      phoneNumber: idx.phoneNumber,
      addressType: idx.addressType,
      houseNo: idx.houseNo,
      city: idx.city,
      pinCode: idx.pinCode,
      landmark: idx.landmark,
      locality: idx.locality,
      default: true
    };
    this.service.putAddress(body).subscribe((success) => {
      if (success.status) {
        this.loadContainer = false;
        this.data.selectAddress = idx._id;
        this.data.selectDefault = true;
        localStorage.setItem(AUTHGWCONSTANTS.addressObject, JSON.stringify(idx));
        StaticMemory.addressObject = idx;
        AppService.addressChange.next(idx);
        const urlParams: any = {
          latitude: idx.location['co-ordinates'][1],
          longitude: idx.location['co-ordinates'][0],
        };
        this.service.getServiceArea(urlParams).subscribe((success) => {
          if (success.status && success.result && success.result.length) {
            localStorage.setItem(AUTHGWCONSTANTS.serAreaObject, JSON.stringify(success.result[0]));
            StaticMemory.isServiceArea = true;
            const oldUrl = sessionStorage.getItem(BuildConfig.xRoute);
            if (oldUrl && oldUrl === window.location.href) {
              window.location.href = oldUrl;
            } else {
              this.router.navigate(['/']).then(() => {
                window.location.reload();
              });
            }
          } else {
            this.loadContainer = true;
            StaticMemory.isServiceArea = false;
            localStorage.removeItem(AUTHGWCONSTANTS.serAreaObject);
            this.locationMessage = success.message;
          }
        });
      }
    },
      (error) => { },
    );
  }

  onSaveAddress(): void {
    if (navigator.onLine) {
      if (this.isValid()) {
        let body: any = {
          fullName: this.data.fullName_text,
          phoneNumber: this.data.phoneNumber_text,
          addressType: this.data.selectAddressType,
          houseNo: this.data.houseNo_text,
          city: this.data.cityDistrictTown_text,
          pinCode: this.data.pinCode_text,
          landmark: this.data.landmark_text,
          locality: this.data.locality_text,
          latitude: this.data.latitude_text,
          longitude: this.data.longitude_text,
          default: this.data.selectDefault,
        };
        if (this.panelExpand === 1) {
          if (!this.addressArray || !this.addressArray.length) {
            body.default = true;
          }
          this.service.postAddress(body).subscribe((success) => {
            if (success.status) {
              this.addressUpdate = true;
              this.onClosePanel();
              this.getAddress();
            } else {
              this.snackbar.openErrorSnackBar(success.message)
            }
          },
            (error: any) => { },
          );
        } else if (this.panelExpand === 2) {
          body.id = this.data.id,
            this.service.putAddress(body).subscribe((success) => {
              if (success.status) {
                this.addressUpdate = true;
                this.onClosePanel();
                this.getAddress();
              }
            },
              (error: any) => { },
            );
        }
      }
    } else {
      this.snackbar.openDefaultSnackBar('No Internet');
    }
  }

  onSubmit(): void {
    const urlParams: any = {
      latitude: StaticMemory.addressObject.location['co-ordinates'][1],
      longitude: StaticMemory.addressObject.location['co-ordinates'][0]
    };
    this.service.getServiceArea(urlParams).subscribe((success) => {
      if (success.status && success.result && success.result.length) {
        localStorage.setItem(AUTHGWCONSTANTS.serAreaObject, JSON.stringify(success.result[0]));
        StaticMemory.isServiceArea = true;
        const oldUrl = sessionStorage.getItem(BuildConfig.xRoute);
        if (oldUrl && oldUrl === window.location.href) {
          window.location.href = oldUrl;
        } else {
          this.router.navigate(['/']).then(() => {
            window.location.reload();
          });
        }
      } else {
        StaticMemory.isServiceArea = false;
        localStorage.removeItem(AUTHGWCONSTANTS.serAreaObject);
        this.snackbar.openErrorSnackBar(success.message);
      }
    },
      (error) => { },
    );
  }

  onDelete(id: string): void {
    if (window.confirm('Are you sure want to delete this?')) {
      this.service.deletAddress(id).subscribe((success) => {
        if (success.status) {
          this.addressUpdate = true;
          this.getAddress();
          this.onClosePanel();
        }
      });
    }
  }

  isValid(): boolean {
    if (this.panelExpand === 1 || this.panelExpand === 2) {
      if (this.data.fullName_text === null || this.data.fullName_text === '') {
        this.snackbar.openErrorSnackBar('Enter full name.');
        return false;
      } else {
        this.data.fullName_text = this.data.fullName_text.replace(
          this.data.fullName_text[0],
          this.data.fullName_text[0].toUpperCase(),
        );
      }
      if (this.data.pinCode_text === null || this.data.pinCode_text === '') {
        this.snackbar.openErrorSnackBar('Enter pin code.');
        return false;
      }
      // if (!new PinCodeValidator().isAvailable(this.data.pinCode_text)) {
      //   this.snackbar.openErrorSnackBar('Sorry, Currently this pin code is not serviceable.');
      //   return false;
      // }
      if (this.data.cityDistrictTown_text === null || this.data.cityDistrictTown_text === '') {
        this.snackbar.openErrorSnackBar('Enter city.');
        return false;
      } else {
        this.data.cityDistrictTown_text = this.data.cityDistrictTown_text.replace(
          this.data.cityDistrictTown_text[0],
          this.data.cityDistrictTown_text[0].toUpperCase(),
        );
      }
      if (this.data.phoneNumber_text === null || this.data.phoneNumber_text === '') {
        this.snackbar.openErrorSnackBar('Enter contact number');
        return false;
      } else if (this.data.phoneNumber_text.toString().length < 10) {
        this.snackbar.openErrorSnackBar('Enter valid contact number');
        return false;
      }
      if (this.data.selectAddressType === null || this.data.selectAddressType === '') {
        this.snackbar.openErrorSnackBar('Select address type');
        return false;
      }
    }
    return true;
  }

  isPinValid(): void {
    if (this.data.pinCode_text !== null) {
      let idx = this.data.pinCode_text.toString();
      if (idx.length >= 5) {
        idx = idx.substring(0, 5);
        this.data.pinCode_text = parseInt(idx, 10);
      }
    }
  }

  isMobValid(): void {
    if (this.data.phoneNumber_text !== null) {
      let contact = this.data.phoneNumber_text.toString();
      if (contact.length >= 10) {
        contact = contact.substring(0, 9);
        this.data.phoneNumber_text = parseInt(contact, 10);
      }
    }
  }
}

